import { tv } from 'tailwind-variants';

import { base } from './base';

import type { ComponentPropsWithRef } from 'react';
import type { VariantProps } from 'tailwind-variants';

const label = tv({
  extend: base,
  base: 'font-inter',
  variants: {
    size: {
      xxl: 'text-[1.5rem] leading-8',
      xl: 'text-[1.25rem] leading-7',
      lg: 'text-[1rem] leading-6',
      md: 'text-[0.875rem] leading-5',
      sm: 'text-[0.75rem] leading-4',
      xs: 'text-[0.6875rem] leading-4',
    },
  },
  defaultVariants: {
    size: 'md',
    italic: false,
  },
});

export type LabelVariants = VariantProps<typeof label>;

type LabelProps = ComponentPropsWithRef<'label'> & LabelVariants;

function Label({ className, size, weight, italic, disabled, tracking, ...rest }: LabelProps) {
  return <label className={label({ size, weight, italic, disabled, tracking, class: className })} {...rest} />;
}

export { label, Label };
